
// localstorage | sessionstorage key name
export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const DARK_MODE_KEY = "darkMode";
export const USER_DETAILS_KEY = "user";

// DEFAULT MESSAGES
export const DEFAULT_ERROR_MSG = "Something went wrong!"

// Shared top-nav destinations for the ScoreUrl admin console. Lives here (not inside the
// ScoreUrl folder) because both ScoreUrl.jsx and the Score landing page render the same header
// bar and need the same tab list to stay in sync — keeping one copy avoids them drifting apart.
export const SCORE_URL_TABS = [
  { key: "artist", label: "Artist URLs", path: "/artist_urls" },
  { key: "weekly", label: "Weekly URLs", path: "/weekly_urls" },
];
